import axios from "axios";
import { buildHeaders } from "../_headers.util";

const API_URL = `${process.env.VUE_APP_API_URL}settings/imports`;

export default {
  meta() {
    return axios.get(`${API_URL}/meta`, { headers: buildHeaders() });
  },

  history(companyId = null) {
    return axios.get(API_URL, { headers: buildHeaders({}, { companyId }) });
  },

  downloadTemplate(module, companyId = null) {
    return axios.get(`${API_URL}/template/${module}`, {
      headers: buildHeaders({}, { companyId }),
      responseType: "blob",
    });
  },

  preview({ module, import_mode, file, companyId = null }) {
    const fd = new FormData();
    fd.append("module", module);
    fd.append("import_mode", import_mode);
    fd.append("file", file);

    return axios.post(`${API_URL}/preview`, fd, {
      headers: buildHeaders({}, { multipart: true, companyId }),
    });
  },

  extractPay100({ data_file, tax_file, password, companyId = null }) {
    const fd = new FormData();
    fd.append("data_file", data_file);
    fd.append("tax_file", tax_file);
    fd.append("password", password);

    return axios.post(`${API_URL}/pay100/extract`, fd, {
      headers: buildHeaders({}, { multipart: true, companyId }),
    });
  },

  previewPay100Artifact({ module, import_mode, artifact_path, companyId = null }) {
    return axios.post(
      `${API_URL}/pay100/preview`,
      { module, import_mode, artifact_path },
      { headers: buildHeaders({}, { companyId }) }
    );
  },

  downloadPay100Artifact(artifactPath, companyId = null) {
    return axios.get(`${API_URL}/pay100/download`, {
      headers: buildHeaders({}, { companyId }),
      responseType: "blob",
      params: { artifact_path: artifactPath },
    });
  },

  commit(batchId, companyId = null) {
    return axios.post(`${API_URL}/${batchId}/commit`, {}, { headers: buildHeaders({}, { companyId }) });
  },

  repairRolePermissions({ companyId = null, useCentral = false } = {}) {
    if (useCentral && companyId) {
      return axios.post(
        `${process.env.VUE_APP_API_URL}companies/${companyId}/repair-role-permissions`,
        {},
        { headers: buildHeaders() }
      );
    }

    return axios.post(
      `${process.env.VUE_APP_API_URL}settings/migration/repair-role-permissions`,
      {},
      { headers: buildHeaders({}, { companyId }) }
    );
  },
};
